import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  zones: [],
};

export const usersDataSlice = createSlice({
  name: 'zones',
  initialState,
  reducers: {
    setZones(state, action) {
      state.zones = action.payload;
    },
  },
});

export const getState = (rootState: RootState) => rootState.usersData;
export const getZones = (rootState: RootState) => rootState.usersData.zones;

export const { setZones } = usersDataSlice.actions;
